module.exports = __webpack_public_path__ + "assets/img/picture2.4d4b0c18.png";